import {Injectable} from '@angular/core';
import {SharedService} from "./sharedService";
import {PagerDataObject} from "../entities/pagerDataObject";
import {HttpClient} from "@angular/common/http";
import {Observable} from 'rxjs';

@Injectable()
export class SourceService {

    constructor(private http: HttpClient, private sharedService: SharedService) {
    }

    getData(query: string): Observable<PagerDataObject> {
        return this.http.get<PagerDataObject>(this.sharedService.apiUrl('api/ifus', "/" + query));
    }

    getTotalIfuList(): Observable<any[]> {
        return this.http.get<any[]>(this.sharedService.apiUrl(this.sharedService.control_api_prf + '/process/ifu/list'));
    }

    getTotalSourceList(): Observable<any[]> {
        return this.http.get<any[]>(this.sharedService.apiUrl(this.sharedService.control_api_prf + '/process/source/list'));
    }

    getRiskList(query: string): Observable<any> {
        return this.http.get<any[]>(this.sharedService.apiUrl('api/ifus/list', "?query=" + query));
    }

    getTotalExecutiveList(): Observable<any[]> {
        return this.http.get<any[]>(this.sharedService.apiUrl(this.sharedService.control_api_prf + '/process/executive/list'));
    }

    getSourceList(): Observable<any> {
        return this.http.get<any[]>(this.sharedService.apiUrl(this.sharedService.control_api_prf + '/process/source/list', "?new=true"));
    }

    getExecutiveList(): Observable<any> {
        return this.http.get<any[]>(this.sharedService.apiUrl(this.sharedService.control_api_prf + '/process/executive/list', "?new=true"));
    }

}
